import { render, staticRenderFns } from "./ProcessosAdministrativos.vue?vue&type=template&id=25e44d5a&scoped=true"
import script from "./ProcessosAdministrativos.vue?vue&type=script&lang=js"
export * from "./ProcessosAdministrativos.vue?vue&type=script&lang=js"
import style0 from "./ProcessosAdministrativos.vue?vue&type=style&index=0&id=25e44d5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e44d5a",
  null
  
)

export default component.exports